module.exports = __webpack_public_path__ + "img/encabezado.b8e30a22.png";